module.exports = __webpack_public_path__ + "img/zncs-zs.a61b472c.png";